import React from 'react';
import { useTranslations } from 'next-intl';

import Modal from '@monofront/design-system/organisms/Modal';

interface IPreparingOrderNoticeModalProps {
  isOpen: boolean;
  hide: () => void;
  children: React.ReactNode;
}

export const PreparingOrderNoticeModal: React.FC<
  IPreparingOrderNoticeModalProps
> = ({ isOpen, hide, children }) => {
  const t = useTranslations('Global');
  const tAccount = useTranslations('Account');

  return (
    <>
      <Modal
        isOpen={isOpen}
        UNSAFE_className="preparing-order-notice-modal"
        centered
        externalToggle={hide}
      >
        <h3 className="tw-lf-title-sm tw-mb-6 tw-text-center">
          {tAccount('orderTrackingModalTitle')}
        </h3>

        {children}

        <div className="tw-mt-6 tw-flex tw-justify-center">
          <button
            type="button"
            onClick={hide}
            className="tw-lf-button tw-lf-button-primary tw-lf-button-md"
          >
            {t('understood')}
          </button>
        </div>
      </Modal>
      <style jsx>{`
        :global(.preparing-order-notice-modal) {
          max-width: 560px;
          padding: var(--space-6);
        }
      `}</style>
    </>
  );
};
